import { ObjectLiteral } from '~/types/generics';

import { IProcessFile } from '../processes/types';

export enum IActivitiesTypes {
  GET_START_EVENT_REQUEST = '@activities/GET_START_EVENT_REQUEST',
  GET_START_EVENT_SUCCESS = '@activities/GET_START_EVENT_SUCCESS',
  GET_START_EVENT_FAILURE = '@activities/GET_START_EVENT_FAILURE',
}

export interface IGetStartEventRequestAction {
  type: typeof IActivitiesTypes.GET_START_EVENT_REQUEST;
  payload: {
    id: string;
  };
}
export interface IGetStartEventSuccessAction {
  type: typeof IActivitiesTypes.GET_START_EVENT_SUCCESS;
  payload: {
    startEvent: IStartEvent;
  };
}
export interface IGetStartEventFailureAction {
  type: typeof IActivitiesTypes.GET_START_EVENT_FAILURE;
}

export type IActivitiesActionTypes =
  | IGetStartEventRequestAction
  | IGetStartEventSuccessAction
  | IGetStartEventFailureAction;

export interface IStartEvent {
  id: string;
  name: string;
  created: string;
  processDefinitionId: string;
  processDefinitionName: string;
  processDefinitionKey: string;
  processInstanceId: string;
  superProcessInstanceId: string;
  rootProcessInstanceId: string;
  processStartTime: string;
  nomeSolicitacao: string;
  nomeExecucao: string;
  registradoPorId: string;
  registradoPor: string;
  tenantId: string | null;
  files: IProcessFile[];
  variables: ObjectLiteral;
  startTime: string;
  endTime: string;
  versionTag: string;
  state?: string;
}

export interface IActivitiesState {
  readonly loadingStartEvent: boolean;

  readonly startEvent: IStartEvent | undefined;
}
